
<template>
    <div class="loader"  v-if="dialog">
        <div class="centerScreen">
            <el-progress type="circle" :percentage="percent"></el-progress>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/main'

export default {
    data () {
        return {
            dialog: false,
            percent: 0
        }
    },
    async created () {
        eventBus.$on('showProgressBar', () => {
            this.dialog = true
        })
        eventBus.$on('hideProgressBar', () => {
            this.dialog = false
        })
        eventBus.$on('updatePercent', (data) => {
            this.percent = parseFloat(data.percent)
        })
    }
}
</script>
<style lang="scss">
.centerScreen{
    .el-progress__text{
        font-size: 20px !important;
        font-weight: bold !important;
        color:#000000 !important;
    }
}
</style>
<style scoped>
.centerScreen {
  position: absolute;
  width: 100px;
  height: 50px;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -25px;
}

.loader {
  position:fixed;
  top: 0;
  z-index: 99999;
  left: 0;
  width:100%;
  height:100%;
  background-color: rgba(103, 103, 103, 0.5);
  vertical-align: middle;
}

</style>
